module.exports = __webpack_public_path__ + "static/media/logo_header_page.68e25878.png";